/**
 *
 * @module entry
 * @desc {SDK.Services.Internal} entry point
 *
 */

import Telemetry from './telemetry/entry';
import Dust from './dust/entry';

/**
 *
 * @typedef SDK.Services.Internal
 * @type {Object}
 *
 * @property {Telemetry} Telemetry
 * @property {Dust} Dust
 *
 */

/**
 *
 * @type {SDK.Services.Internal}
 *
 */
export default {

    Telemetry,
    Dust

};



// WEBPACK FOOTER //
// ./src/services/internal/entry.js